import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Helmet } from "react-helmet-async";
import Header from "components/headers/light.js";
import Footer from "components/footers/SimpleFiveColumn.js";
// ⬇️ swap this:
import ContactForm from "components/forms/ContactForm.js";

export default () => {
  return (
    <AnimationRevealPage>
      <Helmet>
        <title>Contact Us | EthosHub</title>
        <meta name="description" content="Get in touch with the EthosHub team. We're here to answer questions about our anonymous workplace reporting platform and help you find the right plan." />
        <link rel="canonical" href="https://www.ethoshub.io/contact" />
        <meta property="og:title" content="Contact Us | EthosHub" />
        <meta property="og:description" content="Have a question? Want to book a demo? Contact the EthosHub team." />
        <meta property="og:url" content="https://www.ethoshub.io/contact" />
      </Helmet>
      <Header />
      <ContactForm title="Contact Us" />
      <Footer />
    </AnimationRevealPage>
  );
};